import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSessionSelector } from 'redux/selectors';
import { PartnerLogo } from '../PartnerLogo';
import { StyledHeaderBranding } from './HeaderBranding.styled';
import { StyledHeaderLogo } from './HeaderLogo.styled';

export default interface IHeaderBranding {
  role?: React.AriaRole;
}

export const HeaderBranding: React.FC<IHeaderBranding> = (props) => {
  const { partner_name } = useSessionSelector();

  return (
    <StyledHeaderBranding {...props}>
      <StyledHeaderLogo>
        <PartnerLogo partnerName={partner_name} />
      </StyledHeaderLogo>
      <h1>
        <FormattedMessage id="message.globalTitle" />
      </h1>
    </StyledHeaderBranding>
  );
};
